import { Langs } from "../domain/enums/common/LangsEnum";
import { TranslationService } from "../domain/services/TranslationService";
import { BaseServiceImpl } from "./BaseServiceImpl";

export class TranslationServiceImpl
    extends BaseServiceImpl
    implements TranslationService
{
    static _instance: TranslationService;
    private constructor() {
        super();
    }
    static getInstance(): TranslationService {
        if (!TranslationServiceImpl._instance) {
            TranslationServiceImpl._instance = new TranslationServiceImpl();
        }
        return TranslationServiceImpl._instance;
    }

    private readonly translateEndpoint = "/api/v1/translateObject";

    private normalizeLang(lang: Langs | string) {
        const s = String(lang);
        if (s === "ua") return "uk";
        if (s === "en") return "en-GB";
        return s;
    }

    async translateObjectFields(
        translationFields: Record<string, string>,
        sourceLang: Langs,
        targetLang: Langs
    ): Promise<Record<string, string>> {
        try {
            return this.post(this.translateEndpoint, {
                object: translationFields,
                targetLang: this.normalizeLang(targetLang),
                sourceLang: this.normalizeLang(sourceLang),
            });
        } catch (err) {
            console.log("Error in NewsServiceImpl.translate");
            console.log(err);
        }
    }
}

export function translationServiceFactory(): TranslationService {
    return TranslationServiceImpl.getInstance();
}
